import { useTranslation } from 'react-i18next'

import { Body1, Body2 } from '@ui/Typography'

import { useWindowResize } from '@utils/domUtils'

import { Box } from '@shared/components/Box'

export const UsedMarginTooltipNew = () => {
  const { t } = useTranslation()
  const isMobile = useWindowResize()
  const Label = isMobile ? Body1 : Body2
  return (
    <Box flex direction='column'>
      <Box>
        <Label>{t('Markets.UsedMarginTooltipNew.UsedMargin')}</Label>
      </Box>
      <Box>
        <Label>{t('Markets.UsedMarginTooltipNew.MarginLevel')}</Label>
      </Box>
    </Box>
  )
}
